<template>
   <div class="cp-worktab">
     <el-tabs v-model="activeTab" type="border-card" @tab-remove="removeTab" @tab-click="clickTab">
       <el-tab-pane
        style="height:90%;overflow-y:auto;overflow-x:hidden;"
         v-for="t in worktabs"
         :key="t.name"
         :label="t.tabname"
         :name="t.name"
         :closable="t.name !== 'my'"
       >
       </el-tab-pane>
     </el-tabs>
   </div>
 </template>
 <script>
 export default {
   created () {
     // 进来不是主页时等list加载后再更新一次current
     setTimeout(() => {
       this.activeTab = this.$store.state.worktab.current.name
     }, 500)
   },
   watch: {
     '$store.state.worktab.current' (tab) {
       this.activeTab = tab.name
     }
   },
   computed: {
     worktabs () {
       return this.$store.state.worktab.list
     }
   },
   data () {
     return {
       activeTab: 'name'
     }
   },
   methods: {
     clickTab (tab) {
       this.$router.push(this.worktabs[1 * tab.index].path)
     },
     removeTab (name) {
       var paramOb = {
         name:name,
         router : this.$router
       };
       this.$store.dispatch('worktabRemove', paramOb)
     }
   }
 }
 </script>

<style>
.cp-worktab{
  position: absolute;
    left: 210px;
    top: 55px;
    right: 0;
    bottom: 0;
    background-color: #f2f2f2;
}
</style>



// WEBPACK FOOTER //
// src/components/Worktab.vue